<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '560px', maxHeight: '90vh' }"
    header="Migrate to Another Environment"
    (onHide)="reset()">
    <div class="migrate-dialog">
        <div class="migrate-warning">
            <i class="pi pi-exclamation-triangle"></i>
            <div>
                <p>
                    This device will <strong>unclaim from this environment</strong>, restart, and re-register with the
                    target environment using the API key below. It receives a new device identity there; logs, stats and
                    action history remain here.
                </p>
                <p class="text-muted">
                    A "Succeeded" result only means the device accepted the command — verify the device appears on the
                    target dashboard afterwards. If it cannot register with the target it rolls back to this environment
                    automatically within about 30 minutes. Devices on older framework versions will fail with
                    "Action type not handled".
                </p>
            </div>
        </div>

        <div class="form-field">
            <label class="form-label" for="migrateTarget">Target environment</label>
            <p-select
                inputId="migrateTarget"
                [options]="presets"
                optionLabel="label"
                optionValue="value"
                [ngModel]="selectedPreset()"
                (ngModelChange)="onPresetChange($event)"
                appendTo="body"
                class="w-full">
            </p-select>
        </div>

        <div class="form-field">
            <label class="form-label" for="migrateHost">Host</label>
            <input
                pInputText
                id="migrateHost"
                type="text"
                class="w-full"
                placeholder="host or host:port"
                [ngModel]="host()"
                (ngModelChange)="host.set($event)"
                [readOnly]="!isCustom()" />
        </div>

        <div class="form-field" *ngIf="isCustom()">
            <label class="checkbox-label">
                <p-checkbox [binary]="true" [ngModel]="secure()" (ngModelChange)="secure.set($event)"></p-checkbox>
                <span>Use HTTPS</span>
            </label>
        </div>

        <div class="form-field">
            <label class="form-label" for="migrateApiKey">Tenant API key (target environment)</label>
            <input
                pInputText
                id="migrateApiKey"
                type="password"
                class="w-full"
                autocomplete="off"
                placeholder="proav_…"
                [ngModel]="apiKey()"
                (ngModelChange)="apiKey.set($event)" />
            <small class="text-muted">Create one on the target dashboard under Tenants → API keys.</small>
        </div>

        <div class="form-field">
            <label class="form-label" for="migrateDeviceName">New device name (optional)</label>
            <input
                pInputText
                id="migrateDeviceName"
                type="text"
                class="w-full"
                placeholder="Keep current name"
                [ngModel]="newDeviceName()"
                (ngModelChange)="newDeviceName.set($event)" />
        </div>

        <div class="form-field confirm-field">
            <label class="form-label" for="migrateConfirm">
                Type <strong>{{ deviceName() }}</strong> to confirm
            </label>
            <input
                pInputText
                id="migrateConfirm"
                type="text"
                class="w-full"
                autocomplete="off"
                [ngModel]="confirmName()"
                (ngModelChange)="confirmName.set($event)" />
        </div>

        <small *ngIf="confirmName() && validationError()" class="text-error">{{ validationError() }}</small>
        <div *ngIf="error()" class="text-error">{{ error() }}</div>
    </div>

    <ng-template #footer>
        <button pButton type="button" class="p-button-text" (click)="visible.set(false)" [disabled]="submitting()"><span class="p-button-label">Cancel</span></button>
        <button
            pButton
            type="button"
            class="p-button-danger"
            [disabled]="!canSubmit()"
            (click)="migrate()"><i [class]="submitting() ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'" class="p-button-icon" aria-hidden="true"></i><span class="p-button-label">{{ submitting() ? 'Migrating…' : 'Migrate Device' }}</span></button>
    </ng-template>
</p-dialog>
